import type { Locale } from "date-fns";
import { enUS, ru, uz } from "date-fns/locale";

import type { AppLanguage } from "@/shared/config/i18n/config";

/** Maps an AppLanguage to the BCP 47 locale tag used by Intl.DateTimeFormat. */
export const INTL_LOCALE_MAP: Record<AppLanguage, string> = {
  uz: "uz-UZ",
  "uz-cyrl": "uz-Cyrl-UZ",
  ru: "ru-RU",
  en: "en-US",
};

/** Maps an AppLanguage to the matching date-fns Locale object. */
const DFNS_LOCALE_MAP: Record<AppLanguage, Locale> = {
  uz,
  "uz-cyrl": uz,
  ru,
  en: enUS,
};

/** Returns the Intl locale string for the given app language, defaulting to uz-UZ. */
export function toIntlLocale(language: string): string {
  return INTL_LOCALE_MAP[language as AppLanguage] ?? "uz-UZ";
}

/** Returns the date-fns Locale for the given app language, defaulting to uz. */
export function toDfnsLocale(language: string): Locale {
  return DFNS_LOCALE_MAP[language as AppLanguage] ?? uz;
}
